import React from 'react';
import './Footer.css';
import { ReactComponent as Logo } from '../../assets/svg/logo.svg';
import { ReactComponent as FooterLogo } from 'assets/svg/logo_big.svg';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer className={'footer'}>
            <div className={'footer-wrapper'}>
                <div className={'footer-content'}>
                    <div className={'footer-logo'}>
                        <Logo />
                        <h3>MUSICAL SHEPHERDS</h3>
                    </div>
                    <div className={'footer-links'}>
                        <a target="blank" href={'#'}>
                            Download Agreement
                        </a>
                    </div>
                    <div className={'footer-links'}>
                        <Link className={'footer-links__link'} to="/">
                            Home
                        </Link>
                        <Link className={'footer-links__link'} to="/dogs">
                            Puppies & Adults
                        </Link>
                        <Link className={'footer-links__link'} to="/gallery">
                            Gallery
                        </Link>
                        <Link className={'footer-links__link'} to="/contacts">
                            Contacts
                        </Link>
                    </div>
                    <p>© 2021 Musical Shepherds, Vadim Dyliko. All rights reserved</p>
                </div>
                <div className={'footer__big-logo'}>
                    <FooterLogo />
                </div>
            </div>
        </footer>
    );
}

export default Footer;
